import { Button } from 'reactstrap'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Link } from 'react-router-dom'

const MySwal = withReactContent(Swal)

const handleAlert = (status, message, iconStatus, callBack, confirmButton = () => null, callBackDismissed) => {
  return MySwal.fire({
    title: status,
    html: message,
    icon: iconStatus,
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    ...(confirmButton && { confirmButtonText: confirmButton() || 'OK'}),
    buttonsStyling: true
  }).then(result => {
    if (result.isConfirmed && callBack) {
      callBack()
    } else if (result.isConfirmed) {
      return true
    }

    if (result.isDismissed && callBackDismissed) {
      callBackDismissed()
    }
  })
}

const handleConfirm = (
  title,
  message,
  icon = 'warning',
  callBackConfirm,
  callBackCancel,
  confirmText = 'Yes',
  cancelText = 'Cancel'
) => {
  return MySwal.fire({
    title,
    html: message,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: {
      confirmButton: 'btn btn-primary mr-1',
      cancelButton: 'btn btn-secondary ms-1'
    },
    buttonsStyling: false
  }).then((result) => {
    if (result.isConfirmed) {
      if (callBackConfirm) {
        callBackConfirm()
      }
      return true
    }

    if (result.isDismissed) {
      if (callBackCancel) {
        callBackCancel()
      }
      return false
    }
  })
}

const ResponseErrorPage = ({ urlBack, dispatch}) => {

  const styles = {
    errorMessage: {
      color: 'red',
      fontSize: '16px',
      fontStyle: 'italic',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '5px',
      backgroundColor: '#f8d7da'
    }
  }

  
  return (
    <div style={styles.errorMessage}>
      Oops! Something went wrong. Please check your network connection or try again later.
      <Button.Ripple
        tag={Link}
        to={urlBack}
        color="primary"
        className="ml-1"
        type="reset"
      >
        Back
      </Button.Ripple>

      <Button.Ripple
        onClick={() => dispatch()}
        color="secondary"
        className="ml-1"
        type="reset"
      >
        Refresh
      </Button.Ripple>

    </div>
  )
}

export { handleAlert, ResponseErrorPage, handleConfirm }
